import React from 'react';

function NoMatch() {
    return (<>Page not found</>);
}

export default NoMatch;
